import {
  FaEnvelope,
  FaPhoneAlt,
  FaMap,
  FaFacebookF,
  FaInstagram,
} from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-blue-900 font-sans text-white">
      <div className="mx-auto max-w-screen-2xl px-6 pb-16 pt-12 lg:px-16 lg:pb-16 lg:pt-16">
        <div className="grid grid-cols-1 gap-5 text-center lg:grid-cols-3 lg:items-start lg:gap-8">
          {/* Social links */}
          <div className="flex justify-center gap-4 lg:col-start-2">
            <a
              href="https://www.facebook.com/"
              aria-label="Facebook"
              className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-blue-500 ring-1 ring-gray-300"
            >
              <FaFacebookF className="h-5 w-5" aria-hidden="true" />
            </a>

            <a
              href="https://www.instagram.com/"
              aria-label="Instagram"
              className="flex h-10 w-10 items-center justify-center rounded-full bg-white ring-1 ring-gray-300"
            >
              <svg
                width="0"
                height="0"
                aria-hidden="true"
                className="absolute"
              >
                <defs>
                  <linearGradient
                    id="footer-instagram-gradient"
                    x1="0%"
                    y1="100%"
                    x2="100%"
                    y2="0%"
                  >
                    <stop offset="0%" stopColor="orange" />
                    <stop offset="50%" stopColor="deeppink" />
                    <stop offset="100%" stopColor="blueviolet" />
                  </linearGradient>
                </defs>
              </svg>

              <FaInstagram
                className="h-5 w-5"
                style={{ fill: "url(#footer-instagram-gradient)" }}
                aria-hidden="true"
              />
            </a>
          </div>

          {/* Copyright and payment partner */}
          <div className="text-sm leading-relaxed lg:col-start-3 lg:pt-1 lg:text-right">
            <p>Copyright © 2026</p>

            <p className="mt-5">
              Globaltix Sdn Bhd is the authorized payment partner for
              Petronas Twin Towers Registration number - 201701013671
              (1227836-K)
            </p>
          </div>
        </div>

        {/* Contact details */}
        <div className="mt-16 grid grid-cols-1 gap-10 text-center lg:mt-16 lg:grid-cols-3 lg:gap-8">
          <div className="flex flex-col items-center">
            <div className="flex h-10 items-center justify-center">
              <FaEnvelope className="h-9 w-9" aria-hidden="true" />
            </div>

            <h2 className="mt-3 text-lg font-bold leading-7">
              Customer Service
            </h2>

            <a
              href="mailto:skybridge@petronas.com.my"
              className="text-sm leading-7 hover:underline"
            >
              skybridge@petronas.com.my
            </a>
          </div>

          <div className="flex flex-col items-center">
            <div className="flex h-10 items-center justify-center">
              <FaPhoneAlt className="h-9 w-9" aria-hidden="true" />
            </div>

            <h2 className="mt-3 text-lg font-bold leading-7">
              Phone Number
            </h2>

            <a
              href="tel:+60323318080"
              className="text-sm leading-7 hover:underline"
            >
              +60 3-2331 8080
            </a>
          </div>

          <div className="flex flex-col items-center">
            <div className="flex h-10 items-center justify-center">
              <FaMap className="h-9 w-10" aria-hidden="true" />
            </div>

            <h2 className="mt-3 text-lg font-bold leading-7">
              Address
            </h2>

            <address className="text-sm not-italic leading-relaxed">
              PETRONAS Twin Towers, Lower Ground (Concourse) Level,
              <br />
              Kuala Lumpur City Centre
              <br />
              50088 Kuala Lumpur, Malaysia
            </address>
          </div>
        </div>
      </div>
    </footer>
  );
}